module.exports = __webpack_public_path__ + "img/mood1.9e5ab32b.png";